import { axios } from '@/services/axios';

const getTriggerById = async (id, currentScope) => {
    const res = await axios.get(`/Trigger/${id}`, {
        headers: {
            'X-RequestScope': currentScope,
        },
    });
    return res.data;
};

export default getTriggerById;
